import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import "../styles/About.css";

const About = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 200);
    }
  }, [location]);

  return (
    <div className="about-page">
      <section id="fullamoda" className="about-hero">
        <div className="about-hero-content">
          <span className="about-eyebrow">Fulla Moda Kariyer</span>

          <h1>Hakkımızda</h1>

          <p className="about-hero-text">
            1998 yılında heyecanlı bir yolculuğa başladık. Bu yolculukta her zaman farklı yönlerimizi keşfettik ve en önemlisi, değişimden vazgeçmedik. Kendimizi dünyanın değişen hızına, sürekli yenilenen beklentilere göre şekillendirdik; çünkü Fulla Moda ailesi olarak insana değer vermek, özen göstermek, kıymetli olduğunu hissettirmek bizim ilk önceliğimiz. Yıllardır sizlerin beklentilerini göz önünde bulundurarak kendimizi yeniliyoruz. Siz günlük hayatın temposu içinde koştururken, biz sizi yansıtan, her zaman iyi hissettiren kıyafetlerle hizmet kalitemizden ödün vermiyoruz. Yurt dışında 4 ülkede faaliyet gösteriyoruz. Türkiye’deki 85 mağazamız, online alışveriş ağımız ve binlerce çalışanımızla, siz iyi hissedin diye yaşamınızda yer buluyoruz.
          </p>

          <div className="about-hero-actions">
            <Link to="/joblist" className="about-primary-btn">
              Açık Pozisyonları İncele
            </Link>

            <a href="#iletisim" className="about-secondary-btn">
              İletişime Geç
            </a>
          </div>
        </div>

        <div className="about-hero-side">
          <div className="about-hero-box-grid">
            <div className="about-hero-box">
              <strong>85+</strong>
              <span>Mağaza</span>
            </div>

            <div className="about-hero-box">
              <strong>7</strong>
              <span>Ülke</span>
            </div>

            <div className="about-hero-box">
              <strong>1350+</strong>
              <span>Çalışan</span>
            </div>

            <div className="about-hero-box">
              <strong>Mağaza + Online</strong>
              <span>Alışveriş</span>
            </div>
          </div>
        </div>
      </section>



      <section className="about-values-section">
        <div id="vizyon" className="about-value-card">
          <span>Vizyonumuz</span>
          <h4>Ulaşılabilir ve tercih edilen marka olmak.</h4>
        </div>

        <div id="misyon" className="about-value-card">
          <span>Misyonumuz</span>
          <h3>Fulla Moda olarak misyonumuz tüm kategorilerde mümkün olan en kaliteli ürünleri, en uygun fiyatlarla ve en geniş seçenek yelpazesiyle müşterilerimize ulaştırmak, akılda kalıcı bir alışveriş deneyimi yaşatmaktır.
          </h3>
        </div>
      </section>



      <section id="iletisim" className="about-contact-section">
        <div className="about-contact-info">
          <span className="about-eyebrow">İletişim</span>
          <h2>Bize Ulaşın</h2>

          <div className="about-contact-item">
            <strong>Adres</strong>
            <span>Bahçekapı Mh. 2460. Sk. No: 20 Şaşmaz-Etimesgut / Ankara</span>
          </div>

          <div className="about-contact-item">
            <strong>Telefon</strong>
            <a href="tel:+9008504400006">+90 850 440 00 06</a>
          </div>

          <div className="about-contact-item">
            <strong>Email</strong>
            <a href="mailto:info@fullamoda.com">info@fullamoda.com</a>
          </div>
        </div>

        <div className="about-map-wrapper">
          <iframe
            title="Fulla Moda Konum"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3067.127478043731!2d32.7046278!3d39.9459952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d337e640f6dd75%3A0x66e27656702f14b6!2sFullamoda%20%C4%B0stanbul%20Yolu!5e1!3m2!1str!2str!4v1715860540772!5m2!1str!2str"
            allowFullScreen
            loading="lazy"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default About;